import React, { useState } from "react";
import { createData } from "../../utility/adminApi";
import CancelIcon from "@mui/icons-material/Cancel";
import { notify } from "../../components/toastify";

function ChangePassword({ singleData, setChangePasswordTab }) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      role_id: singleData?.roles[0]?.id,
      firstname: singleData?.firstname,
      lastname: singleData?.lastname,
      email: singleData?.email,
      address: singleData?.address,
      phoneno: singleData?.phoneno,
      old_password: oldPassword,
      new_password: newPassword,
    };

    const response = await createData("users/profile_update", payload);
    const errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      notify(
        response?.response?.data?.message || "Failed to update password",
        "error",
      );
    } else {
      notify("Password updated successfully", "success");
      setChangePasswordTab(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setChangePasswordTab(false)}
        />
      </div>

      <h2 className="text-2xl font-medium text-center">Change Password</h2>
      <form
        onSubmit={handleSubmit}
        className="py-12 flex flex-col justify-center items-center gap-6"
      >
        <div className="flex flex-col lg:flex-row flex-wrap justify-center gap-6">
          <div className="flex flex-col">
            <label htmlFor="old_password">Old Password</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Old password"
              type="password"
              id="old_password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="new_password">New Password</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="New password"
              type="password"
              id="new_password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
        </div>
        <button
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          Update Password
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
